import { useEffect } from "react";
import { v4 as uuid } from "uuid";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { benefitsHeroBannerV3 } from "@/assets/images";
import { Button } from "@/pages/quiz/15000/components/Button";

const BenefitsCompareBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  useEffect(() => {
    window.dataLayer.push({
      eventId: uuid(),
      event: "medical_history_enter",
    });
  }, []);

  return (
    <>
      <p className="text-4xl mb-6 text-new-design-gray-500 font-medium whitespace-normal break-keep hyphens-none">
        Are you ready to lose weight safely & quickly?
      </p>

      <img src={benefitsHeroBannerV3} alt="SkinnyRx benefits" />

      <Button onClick={() => setQuestionAnswer(true)} />
    </>
  );
};

export { BenefitsCompareBanner };
